import _ from 'lodash';

function EventRecordCtrl($rootScope, $scope, $interval, $stateParams, $timeout, $sce, toastr, AuthService, AnalysisService, PlanService, AppContextService) {
  'ngInject';

  var vm = this;
  vm.appContext = AppContextService.context;
  vm.view = 'movement';
  vm.team = 'my_team';




  var patterns;

  var getGameInfo = function() {
    var data = {
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
      game_id: $stateParams.id,
    };
    PlanService.getGameInfo(data)
      .then(function (res) {
        vm.date = res.data.date;
        vm.progressTime = res.data.progress_time;
        if (!vm.progressTime) {
          vm.progressTime = '00:00:00';
        }
      })
      .catch(function (error) {
        console.log('ERROR ' + error);
      });
  }
  getGameInfo();


  var progressTimer;
  //진행시간
  vm.setInterval = function () {
    let pTime = vm.progressTime;
    let pSeconds = vm.progressSeconds;
    if (pTime) {
      let hourToSecond = parseInt(vm.progressTime.substring(0, 2));
      let minToSecond = parseInt(vm.progressTime.substring(3, 5));
      let secToSecond = parseInt(vm.progressTime.substring(6, 8));

      let sec = (hourToSecond * 3600) + (minToSecond * 60) + secToSecond;
      vm.progressSeconds = sec;
    } else {
      vm.progressSeconds = 0;
    }

    progressTimer = $interval(function () {
      vm.progressSeconds++;
      let hour = parseInt(vm.progressSeconds / 3600, 10);
      let minute = parseInt((vm.progressSeconds - hour * 3600) / 60, 10);
      let second = vm.progressSeconds - hour * 3600 - minute * 60;
      if (hour < 10) {
        hour = '0' + hour;
      }
      if (minute < 10) {
        minute = '0' + minute;
      }
      if (second < 10) {
        second = '0' + second;
      }

      vm.progressTime = hour + ':' + minute + ':' + second;
      // $scope.playerStatus = 'game_ing';
    }, 1000);
  };


  //잠시멈춤 버튼 작동
  vm.timerCtrl = function (type) {
    // if (!vm.commonData.game_id && !vm.commonData.training_id) {
    //   return;
    // }



    if (vm.isTimerRunning) {
      // vm.stopBtnVisible = 'N'; //잠시멈춤 버튼을 클릭 하면 재시작 버튼으로 스위칭 시키기 위해 바인딩 변수값 설정
      $interval.cancel(progressTimer);

      var data = {
        login_id: vm.appContext.user.login_id,
        uuid: vm.appContext.user.uuid,
        game_id: $stateParams.id,
        progress_time: vm.progressTime
      };
      PlanService.setGameInfo(data)
        .then(function (res) {
          // vm.progressTime = res.data.progressTime;
          // if (!vm.progressTime) {
          //   vm.progressTime = '00:00:00';
          // }
          console.log('stop')

        })
        .catch(function (error) {
          console.log('ERROR ' + error);
        });



    } else {
      // vm.stopBtnVisible = 'Y'; //재시작 버튼을 클릭 하면 잠시멈춤 버튼으로 스위칭 시키기 위해 바인딩 변수값 설정
      vm.setInterval();
      console.log('resume')
    }
  }











  vm.reset = function () {
    vm.is_defence = '';
    vm.is_left = '';
    vm.location_id = '';
    vm.movement_id = '';
    vm.appContext.selectedPlayer = null;
    vm.view = 'movement';
    // vm.view = 'location';

    // 선수로 로그인하였을 경우
    if (vm.appContext.role2 === 'player' && vm.team === 'my_team') {
      vm.appContext.selectedPlayer = vm.appContext.user;
    }
  }


  AnalysisService.getLocationList()
    .then(function (res) {
      vm.locations = res.data.data;
    }).catch(function (e) {
      console.log('ERROR ' + e);
    });

  
    var getPatterns = function () {
    vm.reset();
    var data = {
      login_id: vm.appContext.user.login_id,
      game_id: $stateParams.id,
      // uuid: vm.appContext.user.uuid,
      oppo_id: vm.appContext.team_id

    }
    AnalysisService.patterns(data)
      .then(function (res) {
        console.log(res.data)

        // patterns = res.data;
        
        // analysis 앱 기준으로 동작 추가 - movement_id 가 없거나(공격, 수비, 왼발, 오른발) movement_id 가 151보다 큰 동작 사용
        patterns = {
          my_team: _.filter(res.data['my_team'], function(item) {
            return !item.movement_id || item.movement_id > 151;
          }),
          oppo_team: _.filter(res.data['oppo_team'], function(item) {
            return !item.movement_id || item.movement_id > 151;
          })
        };

        showTeamPatterns();
      })
      .catch(function (error) {
        console.log("An error occured : " + error);
      });
  }
  getPatterns();

  var showTeamPatterns = function() {
    if (!patterns) {
      return;
    }

    vm.attack = {
      att: patterns[vm.team][0].att,
      suc: patterns[vm.team][0].suc
    }
    vm.defence = {
      att: patterns[vm.team][1].att,
      suc: patterns[vm.team][1].suc
    }
    vm.left = {
      att: patterns[vm.team][2].att,
      suc: patterns[vm.team][2].suc
    }
    vm.right = {
      att: patterns[vm.team][3].att,
      suc: patterns[vm.team][3].suc
    }

    // patterns[vm.team].splice(0, 3);
    var data = _.cloneDeep(patterns[vm.team]);
    data.splice(0, 4);
    // console.log(patterns[vm.team]);
    // var data = (patterns[vm.team]).splice(0, 3)
    // console.log(data)
    // vm.movements = patterns[vm.team];
    vm.movements = data;
  }




  // analysis 앱 데이터 조회 시작
  // 우리팀 출전선수 데이터 조회
  $scope.$watch('vm.appContext.players.game.my_team.entryMain', function (newVal, oldVal) {
    var team = 'my_team',
      userIds = _.map(newVal, function(item) {
        return item.user_id;
      });

      AnalysisService.getPlayersPredictionData({
        from: vm.date.replace(/\./g, '-'),
        to: vm.date.replace(/\./g, '-'),
        user_ids: JSON.stringify(userIds)
      }).then(function(res) {
        var analysisData = res.data;

        // 공격
        var item = _.find(patterns[team], {
          name: '공격'
        });
        var count = (_.filter(analysisData, {
          type1: '공격'
        })).length;
        item.att = item.att + count;
        item.suc = item.suc + count;

        // 수비
        var item = _.find(patterns[team], {
          name: '수비'
        });
        var count = (_.filter(analysisData, {
          type1: '수비'
        })).length;
        item.att = item.att + count;
        item.suc = item.suc + count;

        // 왼발
        var item = _.find(patterns[team], {
          name: '왼발'
        });
        var count = (_.filter(analysisData, {
          type3: 'L'
        })).length;
        item.att = item.att + count;
        item.suc = item.suc + count;

        // 오른발
        var item = _.find(patterns[team], {
          name: '오른발'
        });
        var count = (_.filter(analysisData, {
          type3: 'R'
        })).length;
        item.att = item.att + count;
        item.suc = item.suc + count;

        _.forEach(patterns[team], function(item) {
          if (item.movement_id) {
            var name = item.name.split('-')[1];

            if (name === '턴' && item.name.split('-')[0] === '트래핑') {
              name = '트래핑-턴';
            }

            var count = (_.filter(analysisData, {
              type4: name
            })).length;
            item.att = item.att + count;
            item.suc = item.suc + count;
          }
        });

        // 데이터 갱신
        showTeamPatterns();
      }).catch(function(err) {
        console.log(err);
      });
  });

  // 상대팀 출전선수 데이터 조회
  $scope.$watch('vm.appContext.players.game.oppo_team.entryMain', function (newVal, oldVal) {
    var team = 'oppo_team',
      userIds = _.map(newVal, function(item) {
        return item.user_id;
      });

      AnalysisService.getPlayersPredictionData({
        from: vm.date.replace(/\./g, '-'),
        to: vm.date.replace(/\./g, '-'),
        user_ids: JSON.stringify(userIds)
      }).then(function(res) {
        var analysisData = res.data;

        // 공격
        var item = _.find(patterns[team], {
          name: '공격'
        });
        var count = (_.filter(analysisData, {
          type1: '공격'
        })).length;
        item.att = item.att + count;
        item.suc = item.suc + count;

        // 수비
        var item = _.find(patterns[team], {
          name: '수비'
        });
        var count = (_.filter(analysisData, {
          type1: '수비'
        })).length;
        item.att = item.att + count;
        item.suc = item.suc + count;

        // 왼발
        var item = _.find(patterns[team], {
          name: '왼발'
        });
        var count = (_.filter(analysisData, {
          type3: 'L'
        })).length;
        item.att = item.att + count;
        item.suc = item.suc + count;

        // 오른발
        var item = _.find(patterns[team], {
          name: '오른발'
        });
        var count = (_.filter(analysisData, {
          type3: 'R'
        })).length;
        item.att = item.att + count;
        item.suc = item.suc + count;

        _.forEach(patterns[team], function(item) {
          if (item.movement_id) {
            var name = item.name.split('-')[1];

            if (name === '턴' && item.name.split('-')[0] === '트래핑') {
              name = '트래핑-턴';
            }

            var count = (_.filter(analysisData, {
              type4: name
            })).length;
            item.att = item.att + count;
            item.suc = item.suc + count;
          }
        });

        // 데이터 갱신
        showTeamPatterns();
      }).catch(function(err) {
        console.log(err);
      });
  });

  // analysis 앱 데이터 조회 끝





  // TODO : 경과시간  
  vm.setResult = function () {

    if (!vm.appContext.selectedPlayer) {
      toastr.error('선수를 선택하세요.');
      return;
    }

    var data = {
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
      game_id: $stateParams.id,
      [$stateParams.type_code + '_id']: $stateParams.id,
      user_id: vm.appContext.selectedPlayer.user_id,
      is_defence: vm.is_defence,
      is_left: vm.is_left,
      movement_id: vm.movement_id,
      location_id: vm.location_id,
      is_success: vm.is_success,
      minute: vm.progressTime.substring(3, 5),
      second: vm.progressTime.substring(6, 8)
    }

    AnalysisService.setResult(data)
      .then(function (res) {
        getPatterns();
        vm.view = 'movement'
      })
      .catch(function (error) {
        console.log("An error occured : " + error);
      });
  }

  // vm.addMovement = function() {
  //   console.log('add')
  //   var data = {
  //     login_id: vm.appContext.user.login_id,
  //     uuid: vm.appContext.user.uuid,
  //     name: 'test'
  //   }
  //   AnalysisService.addMovements(data)
  //     .then(function (res) {
  //       console.log(res)
  //       if (res.data.result == 'SUC') {
  //         toastr.success('동작정보가 추가 되었습니다.');
  //         getPatterns();
  //       } else if (res.data.result == 'DUP'){
  //         toastr.error('동작정보 중복오류가 발생했습니다.');
  //       } else {
  //         toastr.error('동작정보 추가중 오류가 발생했습니다.');
  //       }

  //     })
  //     .catch(function (error) {
  //       console.log("An error occured : " + error);
  //     });


  // }

  vm.addMovement = function () {
    if (!vm.addItemCategory) {
      toastr.error('동작 분류를 입력하세요.');
      return;
    }
    if (!vm.addItemName) {
      toastr.error('동작 이름을 입력하세요.');
      return;
    }
    var data = {
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
      name: vm.addItemCategory + '-' + vm.addItemName
    }
    AnalysisService.addMovements(data)
      .then(function (res) {
        console.log(res)
        if (res.data.result == 'SUC') {
          toastr.success('동작정보가 추가 되었습니다.');
          getPatterns();
          document.getElementById('movement-modal').style.display = 'none'
        } else if (res.data.result == 'DUP') {
          toastr.error('동작정보 중복오류가 발생했습니다.');
        } else {
          toastr.error('동작정보 추가중 오류가 발생했습니다.');
        }
      })
      .catch(function (error) {
        console.log("An error occured : " + error);
      });
  }

  vm.removeMovement = function () {
    if (!vm.removeItem) {
      toastr.error('동작명을 선택하세요.');
      return;
    }
    var data = {
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
      movement_id: vm.removeItem.movement_id
    };
    console.log(data);
    // return;
    AnalysisService.removeMovements(data).then(function (res) {
      if (res.data.result == 'SUC') {
        toastr.success('동작정보가 삭제 되었습니다.');
        document.getElementById('movement-modal').style.display = 'none'
        getPatterns();
      } else if (res.data.result == 'NOT') {
        toastr.error('이 동작은 삭제할 수 없습니다.');
      } else {
        toastr.error('동작정보 삭제중 오류가 발생했습니다.');
      }
    }).catch(function (e) {
      console.log('ERROR ' + e);
    });
  }

  $scope.$watch('vm.team', function (newVal, oldVal) {
    console.log('watch vm.team', oldVal, newVal)
    if (newVal) {
      // 선수로 로그인하였을 경우
      if (vm.appContext.role2 === 'player') {
        if (newVal === 'my_team') {
          vm.appContext.selectedPlayer = vm.appContext.user;
        }
      }

      showTeamPatterns();
    }
  })


  
  // analysis 앱 기준으로 동작 추가
  vm.categories = [
    {
      name: '활동량',
      items: ['워킹', '러닝', '점프', '턴', '스프린트', '속도', '거리', '가속도']
    },
    {
      name: '트래핑',
      items: ['땅볼', '가슴', '허벅지', '이동', '공중볼', '턴']
    },
    {
      name: '드리블',
      items: ['볼터치', '직진', '방향전환', '이동', '페인팅', '팬텀', '크루이프턴', '마르세유턴', '스텝오버', '플리플랩', '맥기디스핀', '스쿱턴', '포커스포커스', '사포', '돌파', '돌파허용']
    },
    {
      name: '패스',
      items: ['논스톱', '원터치', '스루', '2V1', '3자', '킬', '침투', '헤딩', '피드']
    },
    {
      name: '슈팅',
      items: ['원터치', '발리', '오버헤드', '헤딩', '칩샷', '위협', '유효']
    },
    {
      name: '킥',
      items: ['롱', '짧은', '다이렉트', '파넨카', '드롭', '라보나', '스핀', '바이시클', '힐']
    },
    {
      name: '크로싱',
      items: ['얼리', '레이트', '컷백']
    },
    {
      name: '태클',
      items: ['포크', '슬라이딩']
    },
    {
      name: 'GK',
      items: ['캐칭', '세이빙', '일대일', '슈퍼세이브', '실책']
    },
    {
      name: '수비',
      items: ['가로채기', '클리어', '그라운드경합', '공중볼경합', '압박', '세컨볼', '그라운드차단', '공중볼차단', '패스차단']
    },
    {
      name: '세트피스',
      items: ['골킥', '스로잉', '코너킥', '프리킥', '패널티킥']
    },
    {
      name: '경기결과',
      items: ['득점', '실점', '자책골', '파울', '경고', '퇴장', '오프사이드']
    }
  ];
  vm.categoryNames = _.map(vm.categories, 'name');

  // var arr = [];
  // _.forEach(vm.categories, function(item) {
  //   _.forEach(item.items, function(item2) {
  //     arr.push(item.name + '-' + item2);
  //   });
  // });
  
  // _.forEach(arr, function(item, i) {
  //   (function(item, i) {
  //     setTimeout(function() {
  //       var data = {
  //         login_id: vm.appContext.user.login_id,
  //         uuid: vm.appContext.user.uuid,
  //         name: item
  //       }
  //       AnalysisService.addMovements(data)
  //         .then(function (res) {
  //           console.log(res)
  //           if (res.data.result == 'SUC') {
  //             toastr.success('동작정보가 추가 되었습니다.');
  //           } else if (res.data.result == 'DUP') {
  //             toastr.error('동작정보 중복오류가 발생했습니다.');
  //           } else {
  //             toastr.error('동작정보 추가중 오류가 발생했습니다.');
  //           }
  //         })
  //         .catch(function (error) {
  //           console.log("An error occured : " + error);
  //         });
  //     }, i * 500);
  //   })(item, i);
  // });


  // vm.attackOrDefence = 

  // $scope.color = {
  //   name: 'blue'
  // };

  // $rootScope.$emit('base:sidebarEvent', true, true);

  // if ($stateParams.date) {
  //   $scope.$parent.base.commonData.date = $stateParams.date;
  // }



  // //현재 page명 세팅
  // $scope.$parent.base.pageStatus = 'teamRecordMovement';

  // //동작기록 사용자 설정창 활성화 여부 확인
  // $scope.movementsSetting = false;

  // /**
  //  * API 호출 시 parameter 로 사용할 변수
  //  */
  // vm.setResultData = $scope.$parent.base.movementResultData;
  // vm.setResultData.user_id = null;  //팀화면에서는 선수를 선택하고 해당 선수의 user_id를 입력한다. 접속자 user_id는 필요가 없음
  // vm.setResultData.movement_id = null;

  // //동작기록 기본 버튼 텍스트
  // vm.attackBtn = null;
  // vm.defenseBtn = null;
  // vm.leftFootBtn = null;
  // vm.rightFootBtn = null;


  // let userInfo = vm.appContext.userInfo;
  // console.log('userInfo : ', userInfo);
  // let userBasicInfo = {
  //   login_id: userInfo.login_id,
  //   uuid: userInfo.uuid
  // }

  // vm.userInfo = userInfo;

  // vm.metaData = {
  //   movements: null,
  //   locations: null
  // };

  // //추가 동작정보
  // vm.addMovement = {
  //   name: null
  // };

  // //삭제 동작정보
  // vm.removeMovement = {};

  // vm.movementRecord = {
  //   movemnetsText: null,
  //   skills: {
  //     movement: null,
  //     foot: null,
  //     skill: null
  //   },
  //   locations: null
  // }

  // // 훈련 정보 입력에 필요한 데이터 조회
  // // PlanService.getTrainingMeta().then(function(data) {
  // //   $scope.$apply(function() {
  // //     // movements 에서 공격,수비 삭제
  // //     _.remove(data.movements, function (movement) {
  // //       return movement.name === '공격' || movement.name === '수비';
  // //     });
  // //     console.log('getTrainingMeta : ', data);
  // //     vm.metaData.movements = data.movements;
  // //   });
  // // });

  // if(!vm.setResultData.game_id && !vm.setResultData.training_id){
  //   toastr.error('선택하신 일자에 기록된 정보가 없습니다. 먼저 해당일자를 선택하시거나 경기를 시작해주십시오');
  // }
  // //각 팀별 custom 동작 정보 가져오기
  // vm.setMovementsInfo = function(){
  //   let movementsParams = {
  //     login_id: userBasicInfo.login_id,
  //     user_id: userInfo.user_id,
  //     game_id: vm.setResultData.game_id,
  //     training_id: vm.setResultData.training_id
  //   };
  //   AnalysisService.movements(movementsParams).then(function(data){
  //     console.log('movements data : ', data);
  //     $scope.$apply(function() {
  //       vm.attackBtn = data.data[0].name + '<span class="att">' + data.data[0].att + ' / ' + data.data[0].suc + '</span>';
  //       vm.defenseBtn = data.data[1].name + '<span class="att">' + data.data[1].att + ' / ' + data.data[1].suc + '</span>';
  //       vm.leftFootBtn = data.data[2].name + '<span class="att">' + data.data[2].att + ' / ' + data.data[2].suc + '</span>';
  //       vm.rightFootBtn = data.data[3].name + '<span class="att">' + data.data[3].att + ' / ' + data.data[3].suc + '</span>';

  //       _.remove(data.data, function (movement) {
  //         return movement.id === 0;
  //       });
  //       vm.metaData.movements = data.data;
  //     });
  //   });
  // };

  // vm.renderHtml = function(str){
  //   return $sce.trustAsHtml(str);
  // };

  // //화면에 동작정보 세팅
  // vm.setMovementsInfo();

  // //경기장 위치 데이터 조회
  // AnalysisService.getLocationList().then(function(data){
  //   $scope.$apply(function() {
  //     vm.metaData.locations = data.data;
  //   });
  // });

  // // AnalysisService.getLocationList({side:'B'}).then(function(data){
  // //   $scope.$apply(function() {
  // //     console.log('locations : ', data)
  // //     vm.metaData.locations = data.data;
  // //   });
  // // });

  // // 위치 데이터 조회
  // // AnalysisService.locations({
  // //   user_id: 13,
  // //   game_id: 60   // 의미는 없음. 위치목록 조회를 위한 임의의 game_id
  // // }).then(function(data) {
  // //   $scope.$apply(function() {
  // //     // locations 에서 공격,수비 삭제
  // //     _.remove(data.data, function (location) {
  // //       return location.name === '좌측' || location.name === '우측' || location.name === '위' || location.name === '아래' || location.name === '성공' || location.name === '실패';
  // //     });

  // //     vm.metaData.locations = data.data;
  // //   });
  // // });

  // /**
  //  * 동작 기능
  //  */
  // // 버튼 클릭
  // vm.doNext = function($event, step, id, name) {
  //   //경기id체크
  //   // if(!vm.setResultData.user_id){
  //   //   alert('게임을 시작하지 않았습니다.');
  //   //   return;
  //   // }
  //   if(!vm.setResultData.game_id && !vm.setResultData.training_id){
  //     toastr.error('선택하신 일자에 기록된 정보가 없습니다. 먼저 해당일자를 선택하시거나 경기를 시작해주십시오');
  //     return;
  //   }

  //   if (!vm.setResultData.is_defense && step > 1) {
  //     return;
  //   }

  //   if (!vm.setResultData.is_left && step > 2) {
  //     return;
  //   }

  //   if (!vm.setResultData.movement_id && step > 3) {
  //     return;
  //   }

  //   if (!vm.setResultData.location_id && step > 4) {
  //     return;
  //   }

  //   if (!vm.setResultData.loc_code && step > 5) {
  //     return;
  //   }

  //   if(step == '3'){
  //     vm.setStartingPalyers();
  //   }

  //   let li = $($event.currentTarget).parent();
  //   $('.record-container section ul li.step' + step).not(li).removeClass('selected');
  //   $($event.currentTarget).parent().toggleClass('selected');

  //   // 공격/수비
  //   if (step == 1 && vm.setResultData.is_defense == id) {
  //     vm.setResultData.is_defense = null;
  //     vm.movementRecord.skills.movement = null;
  //   } else if (step == 1) {
  //     vm.setResultData.is_defense = id;
  //     vm.movementRecord.skills.movement = name;
  //   }

  //   // 왼발/오른발
  //   if (step == 2 && vm.setResultData.is_left == id) {
  //     vm.setResultData.is_left = null;
  //     vm.movementRecord.skills.foot = null;
  //   } else if (step == 2) {
  //     vm.setResultData.is_left = id;
  //     vm.movementRecord.skills.foot = name;
  //   }

  //   // 동작
  //   if (step == 3 && vm.setResultData.movement_id == id) {
  //     vm.setResultData.movement_id = null;
  //     vm.movementRecord.skills.skill = null;
  //   } else if (step == 3) {
  //     vm.setResultData.movement_id = id;
  //     vm.movementRecord.skills.skill = name;
  //   }

  //   let movement = vm.movementRecord.skills.movement;
  //   let foot = vm.movementRecord.skills.foot;
  //   let skill = vm.movementRecord.skills.skill;

  //   vm.movementRecord.movemnetsText = `(${movement}/${foot}/${skill})`;

  //   // 위치
  //   if (step == 4 && vm.setResultData.location_id == id) {
  //     vm.setResultData.location_id = null;
  //     vm.movementRecord.movemnetsText = `(${movement}/${foot}/${skill})`;
  //     $($event.currentTarget).removeClass('selectLocation');
  //   } else if (step == 4) {
  //     vm.setResultData.location_id = id;
  //     vm.movementRecord.movemnetsText = `(${movement}/${foot}/${skill}) - ${name} - ${id}`;
  //     $('.selectLocation').removeClass('selectLocation');
  //     $($event.currentTarget).addClass('selectLocation');
  //   }

  //   // 추가 위치
  //   // if (step == 5 && vm.setResultData.loc_code == id) {
  //   //   vm.setResultData.loc_code = null;
  //   // } else if (step == 5) {
  //   //   vm.setResultData.loc_code = id;
  //   // }
  // };

  // //동작기록 사용차 추가/삭제 화면 호출
  // vm.movementsUserSet = function(chk) {
  //   $scope.movementsSetting = chk;
  // };



  // vm.preMovementPage = function() {
  //   vm.setResultData.movement_id = null;
  //   vm.setResultData.location_id = null;
  //   $('.selectLocation').removeClass('selectLocation');
  // };

  // // 초기화
  // vm.clearResultData = function() {
  //   vm.setResultData.is_defense = null;
  //   vm.setResultData.is_left = null;
  //   vm.setResultData.movement_id = null;
  //   vm.setResultData.location_id = null;
  //   vm.setResultData.loc_code = null;
  //   vm.setResultData.is_success = null;
  // };

  // vm.setResult = function(isSuccess) {
  //   if(vm.setResultData.game_id){
  //     vm.setGameMovementResult(isSuccess);
  //   }else if(vm.setResultData.training_id){
  //     vm.setTrainingMovementResult(isSuccess);
  //   }
  // }

  // //동작 결과 입력 (훈련)
  // vm.setTrainingMovementResult = function(isSuccess){
  //   console.log('훈련 동작 기록 저장 !!!');
  //   vm.setResultData.is_success = isSuccess;

  //   console.log('훈련 vm.setResultData : ', vm.setResultData);

  //   if(!vm.setResultData.location_id){
  //     toastr.error('선수 위치를 선택해 주십시오!');
  //     return;
  //   }

  //   if(!vm.setResultData.user_id){
  //     toastr.error('선수를 선택하지 않았습니다.!');
  //     return;
  //   }

  //   // let movementId = vm.setResultData.movement_id;
  //   // let user_id = +(vm.setResultData.user_id);

  //   //개인선수 - 동작기록 저장
  //   AnalysisService.setResult(vm.setResultData).then(function(data) {
  //     console.log('개인동작기록 훈련 저장 완료 : ', data);
  //     $scope.targetPlayer = null;
  //     // $scope.targetOppPlayer = null;
  //     vm.setMovementsInfo();
  //     vm.clearResultData();
  //   });
  // }

  // // 동작 결과 입력 (게임)
  // vm.setGameMovementResult = function(isSuccess) {
  //   vm.setResultData.is_success = isSuccess;
  //   if(!vm.setResultData.location_id){
  //     toastr.error('선수 위치를 선택해 주십시오!');
  //     return;
  //   }

  //   if(!vm.setResultData.user_id){
  //     toastr.error('선수를 선택하지 않았습니다.!');
  //     return;
  //   }

  //   let movementId = vm.setResultData.movement_id;
  //   let user_id = +(vm.setResultData.user_id);
  //   let idx = _.findIndex(
  //     $scope.$parent.base.playerGameResultData.players_game_result.per_user_data,
  //     {
  //       'user_id': vm.setResultData.user_id
  //     }
  //   );

  //   // 동작기록할 때 경기 진행 시간 분,초 기록 - 추후에는 경기 진행시간의 분,초 대신 분,초를 직접 입력할 수 있게 수정해야 함
  //   let progressTime = ($scope.$parent.base.commonData.progressTime) ? ($scope.$parent.base.commonData.progressTime).split(':') : '';
  //   if (progressTime.length) {
  //     let hour = parseInt(progressTime[0], 10);
  //     let minute = parseInt(progressTime[1], 10);
  //     let second = parseInt(progressTime[2], 10);

  //     if (hour) {
  //       minute = minute + hour * 60;
  //     }

  //     vm.setResultData.minute = minute;
  //     vm.setResultData.second = second;
  //   }

  //   //개인선수 - 동작기록 저장
  //   AnalysisService.setResult(vm.setResultData).then(function(data) {
  //     // 득점, 도움, 파울 경기기록에 기록
  //     if (movementId == 36 && isSuccess === 'Y') {
  //       $scope.$parent.base.playerGameResultData.players_game_result.per_user_data[idx].goals = '' + (+$scope.$parent.base.playerGameResultData.players_game_result.per_user_data[idx].goals + 1);
  //     } else if (movementId == 37 && isSuccess === 'Y') {
  //       $scope.$parent.base.playerGameResultData.players_game_result.per_user_data[idx].assists = '' + (+$scope.$parent.base.playerGameResultData.players_game_result.per_user_data[idx].assists + 1);
  //     } else if (movementId == 38 && isSuccess === 'Y') {
  //       $scope.$parent.base.playerGameResultData.players_game_result.per_user_data[idx].fouls = '' + (+$scope.$parent.base.playerGameResultData.players_game_result.per_user_data[idx].fouls + 1);
  //     }

  //     //팀전체 동작 기록 저장
  //     vm.setResultData.user_id = null;
  //     AnalysisService.setResult(vm.setResultData).then(function(data) {
  //       // 득점, 도움, 파울 경기기록에 기록
  //       if (movementId == 36 && isSuccess === 'Y') {
  //         $scope.$parent.base.gameResultData.goals = '' + (+$scope.$parent.base.gameResultData.goals + 1);
  //       } else if (movementId == 37 && isSuccess === 'Y') {
  //         $scope.$parent.base.gameResultData.assists = '' + (+$scope.$parent.base.gameResultData.assists + 1);
  //       } else if (movementId == 38 && isSuccess === 'Y') {
  //         $scope.$parent.base.gameResultData.fouls = '' + (+$scope.$parent.base.gameResultData.fouls + 1);
  //       }
  //       $scope.targetPlayer = null;
  //       $scope.targetOppPlayer = null;
  //       vm.setMovementsInfo();
  //       vm.clearResultData();
  //       $scope.$parent.base.setGameResult();
  //     });
  //   });
  // };

  // /**
  //  * 동작정보 입력 타겟 선수 선택 (접속자팀 선수 선택)
  //  */
  // vm.selectTargetPlayer = function(e, user_id, idx) {
  //   if($scope.targetPlayer == idx){
  //     $scope.targetPlayer = null;
  //     vm.setResultData.user_id = null;
  //   }else{
  //     $scope.targetOppPlayer = null;  //상대팀 선수 선택 초기화
  //     $scope.targetPlayer = idx;
  //     vm.setResultData.user_id = user_id;
  //   }
  // }

  // /**
  //  * 동작정보 입력 타켓 선수 선택 (상대팀 선수 선택)
  //  */
  // vm.selectTargetOppPlayer = function(e, user_id, idx) {
  //   if($scope.targetOppPlayer == idx){
  //     $scope.targetOppPlayer = null;
  //     vm.setResultData.user_id = null;
  //   }else{
  //     $scope.targetPlayer = null;  //접속자팀 선수 선택 초기화
  //     $scope.targetOppPlayer = idx;
  //     vm.setResultData.user_id = user_id;
  //   }
  // }

  // //선발선수 조회
  // vm.setStartingPalyers = function() {
  //   console.log('setStartingPalyers exe')
  //   if(vm.setResultData.game_id || vm.setResultData.training_id){
  //     console.log('vm.setResultData : ', vm.setResultData);
  //     //접속자팀 엔트리 목록 조회
  //     let entryParams = {
  //       login_id: userBasicInfo.login_id,
  //       uuid: userBasicInfo.uuid,
  //       game_id: vm.setResultData.game_id,
  //       training_id: vm.setResultData.training_id,
  //       is_oppo: null,
  //       status: 'IN'
  //     };
  //     console.log('entryParams : ', entryParams);
  //     if(!vm.setResultData.training_id){
  //       PlanService.getEntry(entryParams).then(function(data) {
  //         if(data.result == 'SUC'){
  //           console.log('entryParams game', data);
  //           vm.entryPlayers = data.players
  //         }
  //       });
  //     }else{
  //       PlanService.getTrainingEntry(entryParams).then(function(data) {
  //         if(data.result == 'SUC'){
  //           console.log('entryParams training', data);
  //           vm.entryPlayers = data.players
  //         }
  //       });
  //     }

  //     //상대팀 엔트리 목록 조회
  //     if(!vm.setResultData.training_id){
  //       let opoEntryParams = {
  //         login_id: userBasicInfo.login_id,
  //         uuid: userBasicInfo.uuid,
  //         game_id: vm.setResultData.game_id,
  //         is_oppo: 'Y',
  //         status: 'IN'
  //       };
  //       PlanService.getEntry(opoEntryParams).then(function(data) {
  //         if(data.result == 'SUC'){
  //           console.log('opoEntryParams', data);
  //           vm.oppEntryPlayers = data.players
  //         }
  //       });
  //     }
  //   }
  // }

  // // vm.setResultData.movement_id 가 처음 생길 때 div.field 가 나타나서 이벤트 리스너를 등록할 수 있음
  // $scope.$watch('recordMovement.setResultData.movement_id', function(newVal, oldVal) {
  //   /*
  //    * 축구장에서 축구공 근처를 클릭하면 가장 가까운 축구공이 선택되도록 함
  //    */
  //   if (newVal) {
  //     $timeout(function() {
  //       let field = $('div.field');
  //       let balls = field.find('a');
  //       let radius = 15;  // 축구공 반지름

  //       let fieldWidth = field.width();
  //       let fieldHeight = field.height();
  //       let fieldOffset = field.offset();
  //       let bodyZoom = $('body').css('zoom');
  //       field.on('click', function(e) {
  //         // 축구장 클릭 지점을 실제 축구장에서의 위치로 변환
  //         // 축구장 크기는 가로 105m, 세로 65m 로 생각함
  //         // 왼쪽 상단에서 부터의 거리를 계산
  //         // on_run.js 에서 웹브라우저의 크기에 따라 body 에 zoom 으로 확대 축소를 하므로 정확한 계산을 위해서 zoom 값으로 나눠줌
  //         if (typeof e.offsetX !== 'undefined' && typeof e.offsetY !== 'undefined') {
  //           let offsetX;
  //           let offsetY;

  //           // 축구장 클릭
  //           if (e.target.tagName.toLowerCase() === 'div') {
  //             offsetX = e.offsetX;
  //             offsetY = e.offsetY;
  //           }
  //           // 축구공 클릭
  //           else if (e.target.tagName.toLowerCase() === 'a') {
  //             let ballOffset = $(e.target).offset();

  //             offsetX = ballOffset.left - fieldOffset.left + e.offsetX;
  //             offsetY = ballOffset.top - fieldOffset.top + e.offsetY;
  //           }

  //           let positionX = parseInt(offsetX * 105 / fieldWidth / bodyZoom, 10);
  //           let positionY = parseInt(offsetY * 65 / fieldHeight / bodyZoom, 10);

  //           console.log(positionX, positionY);
  //         }

  //         if (e.target.tagName.toLowerCase() === 'div') {   // 축구공 (a 태그) 를 클릭한 경우는 제외함
  //           let gaps = [];

  //           balls.each(function() {
  //             let ball = $(this);
  //             let offset = ball.offset();

  //             gaps.push({
  //               ball: ball,
  //               gap: Math.sqrt(Math.abs(offset.top + radius - e.clientY) * Math.abs(offset.top + radius - e.clientY) + Math.abs(offset.left + radius - e.clientX) * Math.abs(offset.left + radius - e.clientX))
  //             });
  //           });

  //           gaps = _.sortBy(gaps, 'gap');
  //           gaps[0].ball.click();   // 가장 가까운 축구공 클릭
  //         }
  //       });
  //     }, 0);
  //   }
  // });
}

export default {
  name: 'EventRecordCtrl',
  fn: EventRecordCtrl
};
